export interface IDetallePaquete {
  id: string,
  nrogui ?: string,
  nrowhr ?: string,
  shownrowhr ?: string,
  paqdesc: string,
  peso ?: number,
  showpeso ?: string,
  tipo: string,
  tracking ?: string,
  valorasegurado ?: number,
  showvalorasegurado ?: string,
  showtracking ?: string,
  valordeclarado ?: number,
  showvalordeclarado ?: string
  hasWhr ?: boolean
}

export class DetallePaqueteModel implements IDetallePaquete {
  id: string;
  nrogui ?: string;
  nrowhr ?: string;
  paqdesc: string;
  peso ?: number;
  tipo: string;
  tracking ?: string;
  valorasegurado ?: number;
  valordeclarado ?: number;
}


// WEBPACK FOOTER //
// ./src/app/control-app/shared/detalle-notificacion/detalle-notificacion.model.ts